import React, { Component } from 'react';
import newCustomerNumberImage from '../../assets/img/new-customer-number.png'

import './styles.css'
import { Link } from 'react-router-dom';

class NewCustomerNumberBanner extends Component {
  render() {
    return (
      <div className="banner-container">
        <Link to={'/store-summary'}>
          <img src={newCustomerNumberImage} />
        </Link>
      </div>
    );
  }
}

export default NewCustomerNumberBanner;



// WEBPACK FOOTER //
// ./src/components/new-customer-number/new-customer-number-banner.jsx